import { useContext } from 'react';
import { Formik } from 'formik';
import { CircleLoader } from 'components';
import ChannelForm from './components';
import { channelContext, channelSchema } from './ChannelDetailsContext';
import { Container } from '@mui/material';

let ChannelDetails = () => {

    let service = useContext(channelContext);

    return (
        <Container maxWidth="md">
            <Formik
                enableReinitialize={true}
                initialValues={service.channel}
                validationSchema={channelSchema}
                onSubmit={(values, action) => {
                    service.saveChannel(values);
                    action.setSubmitting(false);;
                }}
            >
                <>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false && <ChannelForm />}
                </>
            </Formik>
        </Container>
    )
}

export default ChannelDetails;